import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.customer.somos1_insights"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0 mb-3",
                attrs: { items: _vm.getBreadcrumbs },
              }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("customer_insights.label.somos1_reports")) +
                  " "
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer_insights.button.filter")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              { staticClass: "mt-2" },
              [
                _vm.has_accepted
                  ? _c(VDataTable, {
                      key: _vm.keyDashboardsList,
                      staticClass: "text-center table-inca",
                      attrs: {
                        responsive: "",
                        hover: "",
                        items: _vm.filteredItems,
                        headers: _vm.headers,
                        "hide-default-footer": "",
                        "disable-pagination": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.actions",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                item.report.maintenance
                                  ? _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        { attrs: { icon: "" } },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(VIcon, [
                                                        _vm._v(
                                                          "mdi-information-outline"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [_c("span", [_vm._v("En mantenimiento")])]
                                    )
                                  : _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            name: "somos1_report_item",
                                                            "data-hash-email":
                                                              "asdad",
                                                            "data-region":
                                                              "Lima",
                                                            "data-company":
                                                              "032",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onVer(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(VIcon, [
                                                        _vm._v("mdi-eye"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [_c("span", [_vm._v("Ver reporte")])]
                                    ),
                                _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openDictionary(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("mdi-table-large"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Diccionario")])]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3547547237
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    staticClass: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VCard,
                      { staticClass: "filters-inca" },
                      [
                        _c(
                          VCardTitle,
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                _vm.collapse_filter = !_vm.collapse_filter
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("titles.search_filters")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          VCardText,
                          { staticClass: "pa-2 pt-0" },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "dense" } },
                              [
                                !_vm.filtro.isGeneral
                                  ? _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(VSelect, {
                                          attrs: {
                                            items: _vm.filterOptions,
                                            label: "Filtrar por etiqueta",
                                            clearable: "",
                                            outlined: "",
                                            dense: "",
                                          },
                                          model: {
                                            value: _vm.selectedFilter,
                                            callback: function ($$v) {
                                              _vm.selectedFilter = $$v
                                            },
                                            expression: "selectedFilter",
                                          },
                                        }),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "default mr-1",
                                            attrs: { outlined: "" },
                                            on: { click: _vm.onCleanSearch },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              disabled: !_vm.selectedFilter,
                                              color: "primary",
                                            },
                                            on: { click: _vm.applyFilter },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("btns.search")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("div", {
                                  staticClass: "col-md-12 text-right",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      !_vm.send_token
        ? _c("AgreementsComponent", {
            ref: "agreement",
            on: { onAccept: _vm.onAccept, onClose: _vm.onClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.agreement_text) },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1584626502
            ),
          })
        : _vm._e(),
      _c("TokenComponent", {
        ref: "tokencomponent",
        on: { sendToken: _vm.sendToken },
      }),
      _c(
        "div",
        { staticClass: "vertical-center" },
        [
          _vm.decline
            ? _c(
                VCard,
                { staticClass: " rounded-xl ", attrs: { "min-width": "350" } },
                [
                  _c(VCardText, { staticClass: "p-0" }, [
                    _c("div", { class: "header-alert " + _vm.color }, [
                      _c(
                        "span",
                        { staticClass: "vertical-center circle1" },
                        [
                          _c(
                            VIcon,
                            {
                              staticClass: "vertical-center",
                              attrs: { color: "white" },
                            },
                            [_vm._v("mdi-alert")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "header-body p-4 text-center",
                        staticStyle: {
                          "max-height": "500px",
                          "overflow-y": "scroll",
                        },
                      },
                      [
                        _c("h5", { class: _vm.color + "--text" }, [
                          _vm._v("¡Información incompleta!"),
                        ]),
                        _c("br"),
                        _c("p", { staticClass: "pb-0" }, [
                          _vm._v("Es necesario "),
                          _c("strong", [_vm._v("leer y aceptar el acuerdo")]),
                          _vm._v(" de "),
                          _c("br"),
                          _vm._v("confidencialidad para poder continuar."),
                        ]),
                        _c(
                          "div",
                          { staticStyle: { display: "inline-grid" } },
                          [
                            _c(
                              VBtn,
                              {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  rounded: "",
                                  small: "",
                                },
                                on: { click: _vm.onVolver },
                              },
                              [
                                _c(VIcon, [_vm._v("mdi-chevron-left")]),
                                _vm._v(" Ver contrato de confidencialidad "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }